import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoundDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconHomeRoundDoor"><Path d="M9.5 16.75V20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V10.4481C3.75 9.48035 4.21681 8.57206 5.00367 8.00874L10.2537 4.25022C11.2979 3.50265 12.7021 3.50265 13.7463 4.25022L18.9963 8.00874C19.7832 8.57206 20.25 9.48035 20.25 10.4481V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H14.5V16.75C14.5 15.3693 13.3807 14.25 12 14.25C10.6193 14.25 9.5 15.3693 9.5 16.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconHomeRoundDoor;
